import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import BaseText from 'app/components/common/BaseText'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { isEqual } from 'lodash'
import { PADDING } from 'parkway-web-common'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const HeadTabComponent = ({
  keyTitle,
  total,
  currentTab,
}: {
  keyTitle: string
  total: number
  currentTab: string
}) => {
  const { t } = useTranslation()

  const isSelected = useMemo(() => {
    return isEqual(currentTab, keyTitle)
  }, [keyTitle, currentTab])

  return (
    <BaseRow gutter={[15, 10]} align={'middle'} wrap={false}>
      <BaseCol>
        <BaseTextStyled
          children={t(keyTitle)}
          fontWeight={isSelected ? 'semibold' : 'medium'}
          fontSize="xs"
          opacity={`${isSelected ? 0.9 : 0.6}`}
          $color={`${
            isSelected ? convertedVariables.primaryColor : 'rgba(121, 129, 147)'
          }`}
        />
      </BaseCol>
      <BaseCol>
        <TotalCountWrapper
          $backgroundColor={
            isSelected
              ? convertedVariables.statesBlueLightColor
              : convertedVariables.neutralBlack2Color
          }
        >
          <BaseText
            children={total}
            fontWeight={isSelected ? 'semibold' : 'medium'}
            colorText={isSelected ? 'collapseBackgroundColor' : 'primaryColor'}
            opacity={`${isSelected ? 1 : 0.6}`}
            fontSize="xs"
          />
        </TotalCountWrapper>
      </BaseCol>
    </BaseRow>
  )
}

const TotalCountWrapper = styled.div<{ $backgroundColor?: string }>`
  padding: 3px 6px;
  border-radius: ${PADDING.md};
  height: 24px;
  min-width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props =>
    props?.$backgroundColor ?? convertedVariables.collapseBackgroundColor};
`

const BaseTextStyled = styled(BaseText)<{ $color?: string }>`
  color: ${props => props?.$color ?? convertedVariables.primaryColor};
`
